import React, { useState, useEffect } from 'react';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import adminService from '../services/adminService';

const AdminLogin = () => {
  const [passkey, setPasskey] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Check if already logged in
  useEffect(() => {
    if (adminService.isLoggedIn()) {
      navigate('/admin/dashboard');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!passkey.trim()) {
      setError('Please enter the admin passkey');
      return;
    }

    try {
      setLoading(true);
      setError('');
      
      const response = await adminService.validatePasskey(passkey);
      
      if (response.valid) {
        // Store authentication token in session storage
        sessionStorage.setItem('adminAuth', response.token);
        toast.success('Admin access granted');
        navigate('/admin/dashboard');
      } else {
        setError('Invalid passkey');
      }
    } catch (error) {
      setError(error.message || 'Authentication failed');
      toast.error('Authentication failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="py-5">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-5">
          <Card className="shadow">
            <Card.Header className="bg-primary text-white">
              <h4 className="mb-0">Admin Access</h4>
            </Card.Header>
            <Card.Body className="p-4">
              {error && <Alert variant="danger">{error}</Alert>}
              
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Admin Passkey</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter admin passkey"
                    value={passkey}
                    onChange={(e) => setPasskey(e.target.value)}
                    disabled={loading}
                    autoFocus
                  />
                </Form.Group>
                
                <div className="d-grid">
                  <Button 
                    type="submit" 
                    variant="primary" 
                    disabled={loading}
                  >
                    {loading ? 'Authenticating...' : 'Access Admin Panel'}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </div>
      </div>
    </Container>
  );
};

export default AdminLogin;
